import React, { useEffect, useRef, useState } from 'react';

/**
 * Google AdSense Banner Component
 * Supports different ad formats: horizontal, rectangle, vertical
 * Hides container when ads aren't available to prevent layout gaps
 */
const AdBanner = ({ 
  format = 'horizontal', // 'horizontal', 'rectangle', 'vertical', 'fluid'
  className = '',
  wrapperClassName = '',
  style = {}
}) => {
  const adRef = useRef(null);
  const isAdLoaded = useRef(false);
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    // Check if AdSense script is available
    const checkAdSense = () => {
      if (window.adsbygoogle && adRef.current && !isAdLoaded.current) {
        try {
          window.adsbygoogle.push({});
          isAdLoaded.current = true;
          setShouldShow(true);
        } catch (e) {
          console.log('AdSense error:', e);
        }
      }
    };

    // Initial check
    checkAdSense();
    
    // Retry after a short delay if not available
    const timer = setTimeout(checkAdSense, 500);
    return () => clearTimeout(timer);
  }, []);

  // Different styles based on format - no minHeight to avoid layout gaps
  const getAdStyle = () => {
    switch (format) {
      case 'horizontal':
        return { display: 'block' };
      case 'rectangle':
        return { display: 'block' };
      case 'vertical':
        return { display: 'block', width: '160px' };
      case 'fluid':
      default:
        return { display: 'block' };
    }
  };

  // In development/preview (no AdSense), return null to avoid empty space
  // Check for adsbygoogle availability - if it's not there, don't show the container
  const hasAdSense = typeof window !== 'undefined' && window.adsbygoogle;
  
  if (!hasAdSense) {
    return null;
  }

  return (
    <div 
      className={`ad-container ${className}`}
      style={{ 
        textAlign: 'center',
        overflow: 'hidden',
        ...style 
      }}
    >
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={getAdStyle()}
        data-ad-client="ca-pub-7560363551513725"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdBanner;
